import React from 'react'

function Intertainment() {
  return (
    <div>
    <br/> <br/>
    <h1>thes is Intertainment page</h1></div>
  )
}

export default Intertainment